module.exports = __webpack_public_path__ + "static/media/sampleUTIDFile.84348471.xlsx";